import resourceBookingApi from 'api/helix/resourceBooking';
import {
  HelixApiResourceEnvironmentResponse,
  ResourceEnvironment,
  TemperatureVoteOption,
} from 'store/resource-environment/types';

export interface GetResourceEnvironmentArgs {
  resourceUuid: string;
  /** The resource's own building (`resource.building_uuid`); falls back to the config building when absent. */
  buildingUuid?: string;
}

export const resourceEnvironmentApi = resourceBookingApi.injectEndpoints({
  endpoints: build => ({
    getResourceEnvironment: build.query<ResourceEnvironment, GetResourceEnvironmentArgs>({
      query: ({ resourceUuid, buildingUuid }) => ({
        // The module base URL is `.../building/<config.buildingUuid>/`. A resource shared from another
        // building must be asked about in ITS building, so when we know it we step out of the config
        // segment (`..` is normalised away by the URL parser) and pin the resource's own one. The
        // Hqo-Building-UUID header is pinned too; prepareHeaders only fills it from config when absent.
        url: buildingUuid
          ? `../${buildingUuid}/resources/${resourceUuid}/environment`
          : `resources/${resourceUuid}/environment`,
        headers: buildingUuid ? { 'Hqo-Building-UUID': buildingUuid } : undefined,
      }),
      transformResponse: (result: HelixApiResourceEnvironmentResponse) => result.environment,
    }),
    submitTemperatureVote: build.mutation<void, { resourceId: string; vote: TemperatureVoteOption }>({
      query: ({ resourceId, vote }) => ({
        url: `resources/${resourceId}/environment/vote`,
        method: 'POST',
        body: { vote },
      }),
      // The module's base query wraps retry(maxRetries: 3), which re-fires on
      // ANY error — a vote is non-idempotent and 403/404/429 are expected
      // answers, so one tap must mean at most one POST.
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useGetResourceEnvironmentQuery, useSubmitTemperatureVoteMutation } = resourceEnvironmentApi;
